<div class="modal-header container-fluid">
    <h4 class="modal-title header-2"> Self-healed Objects Details </h4>
    <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="activeModal.dismiss('Cross click')"
    >
      <img
        [src]="
          isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'
        "
      />
    </button>
  </div>
  
  <div class="modal-body container-fluid w-100">
    <div>
      <app-zorro-table
        tableId="self-healed-obj"
        (handleActions)="onRowHandle($event)"
        [columns]="columns"
        [data]="data">
      </app-zorro-table>
    </div>
  </div>